















































































































import Vue from 'vue';
import Component from 'vue-class-component'
import request from '@/util/request'
import api from '@/util/api';
import { NavBar,Form,Field,Button,Toast,Picker,Popup } from 'vant';
Vue.use(NavBar)
   .use(Form)
   .use(Field)
   .use(Button)
   .use(Toast)
   .use(Picker)
   .use(Popup);

@Component
export default class CreateCard extends Vue{
    name = ""
    enName = ""
    industry = ""
    office = ""
    enOffice = ""
    phone = ""
    address = ""
    site = ""
    email = ""
    wxId = ""
    company = ""
    enCompany = ""
    value = ""
    columns = []
    showPicker = false

 

    mounted(){
      this.getIndustry()
    }

    onClickLeft(){
        this.$router.go(-1)
    }

    onConfirm(value: any, index: any) {
        this.$data.showPicker = false
        this.$data.value = value[0]+"："+value[1]
    }

    onCancel() {
        this.$data.showPicker = false
    }

    getIndustry(){
        request.http({
            url:api.getIndustryTree,
        }).then((res: any) => {
            if (res.ret == 200) {
               this.columns = res.data
            }
        })
       
    }

    onSubmit(values: any) {
        if(!/^1[34578]\d{9}$/.test(values.phone)){
            Toast('手机号错误');
            return;
        }
        if(!/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(values.email)){
            Toast('邮箱错误');
            return;
        }
        console.log('submit', values);
        request.http({
            url:api.createCard,
            params:values
        }).then((res: any) => {
            console.log("res",res);
            if (res.ret == 200) {
                Toast.success('创建成功');
                this.$router.push("/cardMode")
            }else{
                Toast.fail('创建失败')
            }
        })
    }
}
